import React from "react";
import Hero from "../components/Hero";
import LocationAtlas from "../components/LocationAtlas";
import About from "../components/About";
import Services from "../components/Services";
import EnergyEstimator from "../components/EnergyEstimator";
import Projects from "../components/Projects";
import SunNeverStops from "../components/SunNeverStops";
import WhySelectra from "../components/WhySelectra";
import Testimonials from "../components/Testimonials";
import FinalCTA from "../components/FinalCTA";
import Contact from "../components/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <LocationAtlas />
      <About />
      <Services />
      <EnergyEstimator />
      <Projects />
      <SunNeverStops />
      <WhySelectra />
      <Testimonials />
      <FinalCTA />
      <Contact />
    </>
  );
}
